import { ICardEvent, ICardTrackEvent } from '../components/card/wl/cardForm/CardFormWL.types';

class CardFormAntiBot {
  private cardEvents: ICardTrackEvent[] = [];

  private startTime: number = Date.now();

  private lastStates: Record<string, string> = {};

  public trackEvent(cardEvent: ICardEvent): void {
    const fieldKey = cardEvent.fieldType;
    const stateKey = `${cardEvent.event}-${cardEvent.isValid ?? 'none'}`;

    if (this.lastStates[fieldKey] !== stateKey) {
      this.cardEvents.push({
        ...cardEvent,
        timestamp: Date.now(),
      });
      this.lastStates[fieldKey] = stateKey;
    }
  }

  public getEvents(): ICardTrackEvent[] {
    return this.cardEvents;
  }

  public getStartTime(): number {
    return this.startTime;
  }

  public getEndTime(): number {
    return this.startTime;
  }

  public reset(): void {
    this.cardEvents = [];
    this.lastStates = {};
    this.startTime = Date.now();
  }
}

export default CardFormAntiBot;
